import { createFileRoute } from "@tanstack/react-router";

import { Logo } from "@/components/PageHeader/RoquaLogo";
import { useTranslation } from "@/i18n/client";

export const Route = createFileRoute("/not-logged-in")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("Sessions");

  return (
    <>
      <title>{t("pages:loginRequired")}</title>
      <div className="flex h-screen bg-primary-900">
        <div className="m-auto rounded-md border-4 border-primary-500 bg-white p-8">
          <div className="flex flex-col items-center justify-center gap-4">
            <Logo />
            {t("sessionExpired")}
          </div>
        </div>
      </div>
    </>
  );
}
